<template>
  <div>
    <Modal title="操作日志" width="1000px" :value="value"  @on-cancel="cancel">
    <Table :columns="columns" :data="tableBody_item"></Table>
    </Modal>
  </div>
</template>
<script>

import moment from "moment";
export default {
  name: "",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    filters: {
    formData(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  },
  data() {
    return {
      disabled : false,
      columns: [],
      tableBody_item: []
    };
  },
  mounted() {
    this.getColumns()
  },
  methods: {

    //table 列
    getColumns() {
      this.columns = [
        {
          title:"修改记录",
          key: "creatorName",
          render: (h, params) => {
            return h("span", params.row.creatorName+params.row.content);
          },
        },
        {
          width:180,
          title:"修改时间",
          key: "creationTime",
          render: (h, params) => {
          return h("span",
                moment(params.row.creationTime).format("YYYY-MM-DD HH:mm:ss"));
          }
        },
      ];
    },

    //关闭子组件时
		cancel() {
        this.$emit("close", false);
      },

    //关闭弹出框
    cancels() {
      this.$emit("close", { cancel: true });
    },

    //根据ID获取详细信息
    async getLogID(id) {
      let respose = await this.$Ajax.get(
        "/api/services/app/UserLeave/GetLogs",
        { params: { id: id } }
      );
    this.tableBody_item = respose.data.result.items
  }
  }
};
</script>
<style lang="less" scoped="scoped">

/deep/ .ivu-select-disabled .ivu-select-selection {
  background-color: #ffffff !important;
  opacity: 1;
  cursor: not-allowed;
  color: rgb(53, 53, 53) !important;
}
</style>

